import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import SubprojectExpenseRecordInfo from './SubprojectExpenseRecordInfo'
import SubprojectExpenseRecordForm from './SubprojectExpenseRecordForm'
import SubprojectExpenseRecordTable from './SubprojectExpenseRecordTable'
import { sessionGetItemStr, sessionGetItemObj, sessionSetItemStr } from '../../utils/sessionHelpers'
import moment from 'moment'
import {
  saveSubProjectExpenseRecord,
  deleteSubProjectExpenseRecord,
} from '../../redux/actions/subprojectExpenseRecord'
import globalMsgUtil from '../../utils/globalMsgUtil'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import { useHistory } from 'react-router-dom'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import SubprojectExpenseRecordView from './SubprojectExpenseRecordView'
import { previewFile } from '../../utils/fileUtil'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadExpensesSubProjectVoucherListFile } from '../../redux/actions/projectBasedItems'

export default function SubprojectExpenseRecordWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isError, setIsError] = useState(false)
  const [isSaveSuccess, setIsSaveSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [requestBody, setRequestBody] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')
  const subProjectCode = sessionGetItemStr('subProjectCode')
  const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  const subExpenseId = sessionGetItemStr('subExpenseId')
  const isViewOnly = !!sessionGetItemStr('isViewOnly')

  let history = useHistory()

  const onSubmit = (data) => {
    console.log('data', data)

    if (data.table.length == 0) {
      notification.open('error', {
        title: globalMsgUtil.MSG_TABLE_LENGTH_OF_ZERO,
      })
      return false
    }

    const formData = new FormData()

    formData.append('Id', subExpenseId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('SubProjectCode', subProjectCode || '')
    formData.append('PeriodNo', periodNo || '')
    formData.append('VoucherNumber', data?.voucherNumber || '')
    formData.append('ReferenceNumber', data?.referenceNumber || '')
    formData.append('Description', data.description || '')
    formData.append('VoucherDate', moment(data.voucherDate).format('YYYY/MM/DD') || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    const checkKeys = ['id', 'voucherNumber', 'referenceNumber', 'voucherDate', 'attachFiles']

    if (data.table.length > 1) {
      data.table.map((item, index) => {
        if (item.id) {
          formData.set(`FormTable[${index}].Id`, item.id || '')
          formData.set(`FormTable[${index}].expenseList`, item.expenseList || '')
          formData.set(`FormTable[${index}].expenseType`, item.expenseType || '')
          formData.set(`FormTable[${index}].expenseTotal`, item.expenseTotal || 0)
        }
      })

      for (const [k, v] of Object.entries(data)) {
        if (!checkKeys.includes(k)) {
          let keys = k.split('_')

          if (keys[0] == 'expenseTotal') {
            formData.set(`FormTable[${keys[1] - 1}].${keys[0]}`, v || 0)
          } else {
            formData.set(`FormTable[${keys[1] - 1}].${keys[0]}`, v || '')
          }
          formData.set(`FormTable[${keys[1] - 1}].Id`, '')
        }
      }
    } else {
      for (const [k, v] of Object.entries(data)) {
        if (!checkKeys.includes(k)) {
          let keys = k.split('_')

          if (keys[0] == 'expenseTotal') {
            formData.set(`FormTable[${keys[1] - 1}].${keys[0]}`, v || 0)
          } else {
            formData.set(`FormTable[${keys[1] - 1}].${keys[0]}`, v || '')
          }

          formData.set(`FormTable[${keys[1] - 1}].Id`, '')
        }
      }
    }

    setRequestBody(formData)
    setIsShowConfirm(true)
  }

  const handleSaveSubprojectExpenseRecord = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveSubProjectExpenseRecord(requestBody)

      if (response) {
        setFormSchema(response.model)
        setRequestBody()
        sessionSetItemStr('subExpenseId', response.model.id)
        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })

        setTimeout(() => {
          if (subExpenseId) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
    }

    setIsShowConfirm(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteExpenseVoucher = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await deleteSubProjectExpenseRecord(subExpenseId)
      if (response) {
        notification.open('success', {
          title: globalMsgUtil.DELETE_SUCCESS,
        })
        setIsShowConfirmDelete(false)
        history.goBack()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
      setIsShowConfirmDelete(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (filePath) => {
    startLoading()
    try {
      var files = filePath?.split('/')
      var file = await downloadExpensesSubProjectVoucherListFile(filePath)

      previewFile(file, files[files.length - 1])
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <SubprojectExpenseRecordInfo schema={formSchema?.projectInfo} />

        {!isViewOnly && !formSchema?.disabled ? (
          <SubprojectExpenseRecordForm
            schema={formSchema?.form}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <SubprojectExpenseRecordView schema={formSchema?.form} />
        )}

        <SubprojectExpenseRecordTable
          schema={formSchema?.form?.formTable}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isViewMode={isViewOnly || formSchema?.disabled}
        />

        <>
          <div>
            <br />
            <Row>
              {isError && (
                <Message showIcon type="error" description={isError} style={{ marginBottom: 10 }} />
              )}
              <Col lg={12} md={12} sm={24} xs={24}>
                {!isViewOnly && !formSchema?.disabled && (
                  <Button
                    color="red"
                    appearance="link"
                    disabled={!formSchema.id}
                    onClick={() => {
                      setIsShowConfirmDelete(true)
                    }}
                  >
                    <Icon icon="trash" size="lg" /> ลบเอกสาร
                  </Button>
                )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <Button
                  color="blue"
                  appearance="link"
                  onClick={() => {
                    onPreview(formSchema?.id)
                  }}
                >
                  <Icon icon="search" size="lg" /> ใบสำคัญจ่าย
                </Button>
                {!isViewOnly && !formSchema?.disabled && (
                  <>
                    <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
                    <CancelButton
                      onClick={() => {
                        history.goBack()
                      }}
                    >
                      ยกเลิก
                    </CancelButton>
                  </>
                )}
              </Col>
            </Row>
          </div>
        </>
      </Panel>

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_DELETE_DOC_TITLE}
        show={isShowConfirmDelete}
        detail={globalMsgUtil.CONFIRM_DELETE_DOC_DETAIL}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleDeleteExpenseVoucher}
      />

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleSaveSubprojectExpenseRecord}
      />
    </>
  )
}
